module.exports = __webpack_public_path__ + "static/media/Logo-Mibact.e5eb6075.gif";